<script>
  import { Label } from "sveltestrap";
  import { dTypeIcon } from "../../editor/component/data.js";
  import { data, dataInfo, currentSpec } from "../../editor/storage.js";
  export let shelfDragStart;
  export let x = "290px";
  export let y = "44px";
  export let layer_specific;
  // preview
  let previewField,
    previewValues = [];
  function seeColumnPreview(event, field) {
    previewField = field;
    previewValues = $data.map((d) => d[previewField]);
    document.querySelector("#column-preview").style.display = "block";
    let target = event.target.getBoundingClientRect();
    document.querySelector("#column-preview").style.top =
      (target.y || event.clientY) - 30 + "px";
    document.querySelector("#column-preview").style.left =
      (target.x + target.width || event.target.offset) + 15 + "px";
    event.target.offset + "px";
  }
  function cancelColumnPreview() {
    document.querySelector("#column-preview").style.display = "none";
  }
  let panel;
  function adjustPosition(node) {
    let moved = {};

    node.addEventListener("mousedown", (event) => {
      // start
      if (event.target.classList.contains("window-drag")) {
        moved.ing = true;
        moved.ox = event.clientX;
        moved.oy = event.clientY;
        moved.px = parseFloat(panel.style.left);
        moved.py = parseFloat(panel.style.top);
      }
    });
    window.addEventListener("mouseup", (event) => {
      moved.ing = false;
    });
    window.addEventListener("mousemove", (event) => {
      if (moved.ing) {
        moved.dx = event.clientX - moved.ox;
        moved.dy = event.clientY - moved.oy;
        node.style.left = moved.px + moved.dx + "px";
        node.style.top = moved.py + moved.dy + "px";
      }
    });
  }
</script>

<div
  class="dupo-menu-pane dupo-third-panel"
  style={`left: ${x}; top: ${y}; width: 240px;`}
  bind:this={panel}
  use:adjustPosition
>
  <div class="dupo-menu-pane-row pt-2 window-drag">
    <h3 class="window-drag">
      <i class="bi bi-table" /> Data columns
    </h3>
  </div>
  <div class="dupo-menu-pane-row column-list">
    {#each $dataInfo.columns as f}
      <div>
        <span
          data-field={f}
          class={"field-badge " + $dataInfo.stats[f].type}
          on:mouseover={(event) => seeColumnPreview(event, f)}
          on:focus={(event) => seeColumnPreview(event, f)}
          on:mouseout={cancelColumnPreview}
          on:blur={cancelColumnPreview}
          draggable="true"
          on:dragstart={(event) => {
            shelfDragStart(event);
          }}
        >
          <i class={"bi bi-" + dTypeIcon[$dataInfo.stats[f].type] + " me-1"} />
          {f}
        </span>
      </div>
    {/each}
    {#each $currentSpec.fronto?.transform || [] as f}
      {#if f.calculate}
        <div>
          <span
            data-field={f.as}
            class={"field-badge calculate"}
            draggable="true"
            on:dragstart={(event) => {
              shelfDragStart(event);
            }}
          >
            <i class={"bi bi-" + dTypeIcon["count"] + " me-1"} />
            {f.as}
          </span>
        </div>
      {/if}
    {/each}
    {#if layer_specific}
      {#each $currentSpec.fronto?.layer[layer_specific]?.transform || [] as f}
        {#if f.calculate}
          <div>
            <span
              data-field={f.as}
              class={"field-badge calculate"}
              draggable="true"
              on:dragstart={(event) => {
                shelfDragStart(event);
              }}
            >
              <i class={"bi bi-" + dTypeIcon["count"] + " me-1"} />
              {f.as}
            </span>
          </div>
        {/if}
      {/each}
    {/if}
    <div>
      <span
        data-field="count"
        data-agg="count"
        class={"field-badge " + "quantitative"}
        draggable="true"
        on:dragstart={(event) => {
          shelfDragStart(event);
        }}
      >
        <i class={"bi bi-" + dTypeIcon["count"] + " me-1"} />
        Count
      </span>
    </div>
  </div>
  <div class="dupo-menu-pane-row description">
    <p class="text-sm py-2">Drag a field to a shelf.</p>
  </div>
</div>
<div id="column-preview" class="text-sm">
  {#if previewField}
    <h4 class="h7"><i class="bi bi-search" /> Preview: {previewField}</h4>
    <i class="bi bi-dot" /><span style="font-weight: 400;">Type</span>: {$dataInfo
      .stats[previewField].type}<br />
    {#if $dataInfo.stats[previewField].type == "continuous"}
      <i class="bi bi-dot" /><span style="font-weight: 400;">Min</span>: {$dataInfo
        .stats[previewField].min}<br />
      <i class="bi bi-dot" /><span style="font-weight: 400;">>Max</span>: {$dataInfo
        .stats[previewField].max}<br />
    {/if}
    <i class="bi bi-dot" /><span style="font-weight: 400;">Values</span>:<br />
    <div style="height: 100px; overflow-y: scroll; border: 1px solid #cccccc;">
      {#each previewValues as v, i}
        <div style="border-bottom: 1px solid #dddddd; padding: 0 0.25rem;">
          <span
            style="display: inline-block; font-family: monospace; width: 30px;"
            >{i}</span
          >{v}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .h7 {
    font-size: 0.9rem;
  }
  .columns-list-panel {
    width: 210px;
  }
  #column-preview {
    display: none;
    position: fixed;
    /* height: 360px; */
    width: 260px;
    padding: 0.5rem;
    background-color: white;
    border: 1px solid black;
    z-index: 999;
  }
  .column-list {
    max-height: 200px;
    overflow-y: scroll;
  }
</style>
